



















































import Vue from "vue";
import Component from "vue-class-component";
import { required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import { Manufacturer, TrackingOrder } from "@/store";

interface Search {
    text: string;
}

interface Inventory {
    description: string;
    id: string;
    manufacturer: Manufacturer;
    partNumber: string;
    quantity: number;
}

@Component({
    mixins: [validationMixin],
})
export default class extends Vue {
    search: Search = {
        text: "",
    };
    submitted: boolean = false;
    searched: boolean = false;
    manufacturer: Manufacturer | null = null;
    trackingOrders: TrackingOrder[] | null = null;

    async mounted() {
        await this.loadManufacturer();
        var response = await this.$http.post<TrackingOrder[]>("/api/v0/orders/tracking/vendor", {
            key: this.slug,
            purchaseOrderNumber: this.purchaseOrderNumber,
        });
        this.trackingOrders = response.data;
        document.title = `${this.manufacturer!.name} Online Order Lookup`;
    }

    async loadManufacturer() {
        var response = await this.$http.get<Manufacturer>(`/api/v0/manufacturers/slug/${this.slug}`);
        this.manufacturer = response.data;
        if (this.manufacturer.hasFavicon) {
            const url = this.manufacturer.faviconUrl;
            const links = document.querySelectorAll("[rel='icon']") as NodeListOf<HTMLLinkElement>;
            links.forEach(link => {
                link.href = url;
            });
        }
    }

    get slug(): string {
        return this.$route.params.slug;
    }

    get purchaseOrderNumber(): string | null {
        return this.$route.params.purchaseOrderNumber;
    }

    get customFooter(): string | undefined {
        return this.manufacturer?.customFooter?.replaceAll("\\n", "\n");
    }

    async submitSearch() {
        this.submitted = true;
        var response = await this.$http.post<TrackingOrder[]>("/api/v0/orders/tracking/vendor", {
            key: this.slug,
            purchaseOrderNumber: this.search.text,
        });
        this.searched = true;
        this.trackingOrders = response.data;
        this.$gtag.event("search", { search_term: this.search.text });
        this.submitted = false;
    }

    validations() {
        return {
            search: {
                text: {
                    required,
                },
            },
        };
    }
}
